/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Registration Field Types:
 *   * `text` - plain text
 *   * `select` - Select box with at least one option. Options array would include key/value pair for each <option> value and display text.
 *   * `checkbox` - Checkbox which will have a value of either true or false
 *
 * @export
 */
export const RegistrationFieldType = {
    Text: 'text',
    Select: 'select',
    Checkbox: 'checkbox'
};
export function instanceOfRegistrationFieldType(value) {
    for (const key in RegistrationFieldType) {
        if (Object.prototype.hasOwnProperty.call(RegistrationFieldType, key)) {
            if (RegistrationFieldType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function RegistrationFieldTypeFromJSON(json) {
    return RegistrationFieldTypeFromJSONTyped(json, false);
}
export function RegistrationFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RegistrationFieldTypeToJSON(value) {
    return value;
}
